// extracted by mini-css-extract-plugin
export default {"wrapper":"ticketLink_wrapper__ALsml","issueWrapper":"ticketLink_issueWrapper__0Fq6j","text":"ticketLink_text__x64JY","icon":"ticketLink_icon__pJNhR","btn":"ticketLink_btn__ekB1x"};